mutation DeleteTagTypes($ids: [ID!]!) {
  deleteTagTypes(ids: $ids) {
    id
  }
}

